import axios from "axios";
import "./baseApi";

const getNotification = () => axios.get("Notification");
const seenNotification = (r) => axios.put("Notification", r);
const setNotificationToken = (r) => axios.post("Notification", r);

export default {
    getNotification,
    seenNotification,
    setNotificationToken,
};
